import SubHeader from '../SubHeader.jsx';

const PageHeader = (props) =>
  SubHeader({
    large: true,
    bgWhite: true,
    ...props,
  });

PageHeader.propTypes = SubHeader.propTypes;

export default PageHeader;
